import { SwRedux } from "app/services/SwRedux";
import { selectActiveOpportunityListId, selectActiveWorkspaceId } from "./selectors";

export function isListActive(listId: string, workspaceId: string) {
    const { commonWorkspace } = SwRedux.getInstance().getState();
    const activeListId = selectActiveOpportunityListId(commonWorkspace);
    const activeWorkspaceId = selectActiveWorkspaceId(commonWorkspace);
    return activeListId === listId && activeWorkspaceId === workspaceId;
}
